import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0E356E"
    },
    secondary: {
      main: "#FF6600"
    },
    error: {
      main: red.A400
    },
    background: {
      default: "#fff"
    },
    yellow: {
      main: "#FFDB00"
    },
    white: "#FFF",
    black: "#000",
    grey: {
      main: "#EEE",
      light: "#F7F7F7",
      dark: "#666666"
    }
  }
});

export default theme;
